module.exports = __webpack_public_path__ + "img/safe.46e694b5.png";